import React, { useCallback, useRef, useState } from 'react'
import { HexColorPicker } from 'react-colorful'
import useClickOutside from '../../utils/useClickOutside'
import PopoverPickerStyle from './PopoverPickerStyle'

export const PopoverPicker = ({ color, onChange }) => {
  const popover = useRef()
  const [isOpen, toggle] = useState(false)

  const close = useCallback(() => toggle(false), [])
  useClickOutside(popover, close)

  const onClickSwatch = () => {
    toggle(true)
    onChange('#1f6498')
  }

  return (
    <PopoverPickerStyle pointerColor={color}>
      <div
        className="swatch"
        style={{ backgroundColor: color }}
        onClick={onClickSwatch}
      />

      {isOpen && (
        <div className="popover" ref={popover}>
          <HexColorPicker color={color} onChange={onChange} />
        </div>
      )}
    </PopoverPickerStyle>
  )
}



// WEBPACK FOOTER //
// ./src/components/colorpicker/PopoverPicker.js